// @flow
import React from 'react';
import {
  Router,
  Route,
  IndexRoute,
  Redirect,
  IndexRedirect,
  browserHistory
} from 'react-router';

import APIContainer from './containers/APIContainer';
import AppContainer from './containers/AppContainer';
import HomeContainer from './containers/HomeContainer';
import VersionContainer from './containers/VersionContainer';
import GuideContainer from './containers/GuideContainer';
import Docs from './pages/Docs';
import NotFound from './pages/NotFound';

type Props = {
  children: Array<React$Element<*>>;
};

const RenderChildren = ({ children }: Props) => (
  <div>
    {children}
  </div>
);

export default () => (
  <Router history={browserHistory} onUpdate={() => window.scrollTo(0, 0)}>
    <Route component={AppContainer} path="/">
      <IndexRoute component={HomeContainer} />
      <Route component={Docs} path="docs">
        <IndexRedirect to="latest" />
        <Route component={VersionContainer} path=":version">
          <IndexRedirect to="guide" />
          <Route component={RenderChildren} path="api">
            <IndexRedirect to="application" />
            <Route component={APIContainer} path=":slug" />
          </Route>
          <Route component={RenderChildren} path="guide">
            <IndexRedirect to="getting-started" />
            <Route component={GuideContainer} path=":slug" />
          </Route>
        </Route>
      </Route>
      <Route component={NotFound} path="/not-found" />
      <Redirect from="*" to="/not-found" />
    </Route>
  </Router>
);



// WEBPACK FOOTER //
// ./src/routes.jsx